import { Difficulty } from '@gdladder/shared/enums';

const MAX_TIER = parseInt(import.meta.env.VITE_MAX_TIER);

interface TierDifficultyRange {
    difficulty: Difficulty;
    name: string;
    minTier: number;
    maxTier: number;
}

export const tierDifficultyRanges: TierDifficultyRange[] = [
    {
        difficulty: Difficulty.EASY,
        name: 'Easy Demon',
        minTier: 1,
        maxTier: 5,
    },
    {
        difficulty: Difficulty.MEDIUM,
        name: 'Medium Demon',
        minTier: 6,
        maxTier: 10,
    },
    {
        difficulty: Difficulty.HARD,
        name: 'Hard Demon',
        minTier: 11,
        maxTier: 15,
    },
    {
        difficulty: Difficulty.INSANE,
        name: 'Insane Demon',
        minTier: 16,
        maxTier: 20,
    },
    {
        difficulty: Difficulty.EXTREME,
        name: 'Extreme Demon',
        minTier: 21,
        maxTier: MAX_TIER,
    },
];

export function getTierDifficultyRange(tier: number) {
    return tierDifficultyRanges.find((range) => tier >= range.minTier && tier <= range.maxTier);
}
